import { Flex, chakra, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import type { AddressFromToFilter } from 'types/api/address';
import type { Transaction } from 'types/api/transaction';

import config from 'configs/app';
import useIsInitialLoading from 'lib/hooks/useIsInitialLoading';
import { useI18n } from 'lib/i18n/context';
import CsvExportDialog from 'ui/csvExport/CsvExportDialog';
import Skeleton from 'ui/shared/chakra/Skeleton';
import ExportButton from 'ui/shared/ExportButton';

interface Props {
  address?: string;
  filterValue?: AddressFromToFilter;
  className?: string;
  isLoading?: boolean;
  items?: Array<Transaction>;
  variant?: 'default' | 'explorer';
}

const TransactionsExportButton = ({ address, filterValue, className, isLoading, items }: Props) => {
  const { t } = useI18n();
  const dialog = useDisclosure();
  const isInitialLoading = useIsInitialLoading(isLoading);
  const isCurrentPageExport = items !== undefined;

  if (!isCurrentPageExport && !config.features.csvExport.isEnabled) {
    return null;
  }

  if (isInitialLoading) {
    return (
      <Flex className={ className } flexShrink={ 0 } alignItems="center">
        <Skeleton h="32px" w={{ base: '120px', lg: '120px' }} borderRadius="sm"/>
      </Flex>
    );
  }

  return (
    <>
      <ExportButton className={ className } onClick={ dialog.onOpen }>
        { t('txs.export') }
      </ExportButton>
      <CsvExportDialog
        isOpen={ dialog.isOpen }
        onClose={ dialog.onClose }
        title={ t('txs.exportTitle') }
        hash={ address }
        resource="csv_export_txs"
        filterType={ address ? 'address' : undefined }
        filterValue={ filterValue }
        fileNameTemplate="transactions"
        exportType="transactions"
      />
    </>
  );
};

export default React.memo(chakra(TransactionsExportButton));
